import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'GET_DRIVER_UNITS_FORMATS_SECTIONS': {
			var { response, payload } = action

			return {
				...state,
				inspection_sections: response,
			}
		}
		default:
			state = crudHandlers(state, action, 'inspection_section')

			return state
	}
}
